import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMedal: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMedal"><Path fillRule="evenodd" clipRule="evenodd" d="M12 1C7.58172 1 4 4.58172 4 9C4 11.5264 5.17108 13.7793 7 15.2454V23.1818L12 20.8289L17 23.1818V15.2454C18.8289 13.7793 20 11.5264 20 9C20 4.58172 16.4183 1 12 1ZM8.5 16.1958C9.5572 16.7109 10.7448 17 12 17C13.2552 17 14.4428 16.7109 15.5 16.1958V20.8182L12 19.1711L8.5 20.8182V16.1958Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMedal;
